module.exports = __webpack_public_path__ + "355c3eae3965c0cd934f07310c47c43a.png";